import { forEach, omit, includes, map } from "lodash";
import { SECTIONS, ELEMENTS } from "./story";
import { BRICKS } from "@titelmedia/bricks";

/* A LIST OF AVAILABLE BLOCKS IN DATO FOR THIS PARTICULAR STORY */
/* MAPS THEM TO EXISTING COMPONENTS OUTLINED IN STORY.JS */
const mapDatoKeysToISF = {
  DatoCmsParagraph: "Paragraph",
  DatoCmsQuote: "Quote",
  DatoCmsImage: "Images",
  DatoCmsHeadline: "Headline",
  DatoCmsHighlight: "Highlight",
  DatoCmsHeroBannerVimeo: "HeroBannerVimeo",
  DatoCmsGallery: "Gallery",
  DatoCmsVideo: "Video",
  DatoCmsImagetext: "ImageText",
  DatoCmsListItem: "ListItem",
  DatoCmsCta: "CTA",
  DatoCmsSeparator: "Separator",
  DatoCmsCredit: "Credits",
};

const {
  Paragraph,
  CTA,
  Images,
  Quote,
  Headline,
  Separator,
  Credits,
} = BRICKS.elements;

const BRICKSModulesToUse = {
  Paragraph,
  Quote,
  Images,
  Headline,
  Separator,
  CTA,
  Credits,
};

export const datoToBF = ({ content }) => {
  let storyContent = [];
  let currentLayout = null;

  forEach(content, (item, index) => {
    // check if first layout, and if so, init
    const t = item.__typename;
    if (includes(t, "Section")) {
      if (currentLayout === null) {
        currentLayout = 0;
      } else {
        currentLayout = currentLayout + 1;
      }
      let layout = {};

      /* Map section divider to existing sections - is there a more elegant way? */
      if (includes(item.sectionId, "feature")) {
        layout.c = SECTIONS.SectionFeature;
      } else if (includes(item.sectionId, "intro")) {
        layout.c = SECTIONS.SectionIntro;
      } else if (includes(item.sectionId, "footer")) {
        layout.c = SECTIONS.SectionFooter;
      } else {
        console.log(
          `No available section type for ${item.sectionId}. Have a look in utilities/dato.js`
        );
        return;
      }

      layout.data = omit(item, ["id", "__typename", "sectionId"]);
      layout.elements = [];
      storyContent.push(layout);
    } else {
      if (index === 0) {
        console.log("Add an intro section divider bitte!");
      }

      if (!ELEMENTS[mapDatoKeysToISF[t]]) {
        console.log(
          `No available element type for ${mapDatoKeysToISF[t]} ${t}. Have a look in utilities/dato.js`
        );
        return;
      }

      let element = {};
      element.type = mapDatoKeysToISF[t];
      console.log("ITEM", item);
      if (BRICKSModulesToUse[element.type]) {
        element.c = BRICKSModulesToUse[element.type];
      } else {
        console.log("an outside element: ", element.type);
        element.c = ELEMENTS[element.type];
      }

      element.data = omit(item, ["id", "__typename"]);
      console.log(element.data);
      if (element.type === "ImageText") {
        element.data.alignReverse = !(index % 2);
      }

      if (element.type === "Quote") {
        element.data.style = "bold";
      }
      if (element.type === "CTA") {
        console.log("CTA", BRICKS.elements);
        // element.c = CTA;
        element.data.text =
          "Dive Into The Wonderful World  of Gucci x The North Face ";
        element.data.buttonText = "Shop the collection";
        console.log(element.data);
      }

      if (item.items) {
        element.data.items = map(
          item.items,
          it => it.fluid || it.responsiveImage
        );
      }

      storyContent[currentLayout].elements.push(element);
    }
  });

  return storyContent;
};

export default datoToBF;
